exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".db-col-select>.el-table .el-table__body tr.selected>td{background-color:#ffefe5!important;color:#333}.db-col-select>.el-table .el-table__body tr.unselectable>td{font-style:italic;color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c24d850","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/query/DbColSelect.vue
// module id = 1664
// module chunks = 1